import { ContentSkeleton } from './ContentSkeleton'
import { SpecificationsTable } from './SpecificationsTable'
import { SectionHeader } from '../../../../UiBlocks'
import { useProductAttributes } from '../../../state'
import { AttachmentsComponent } from '../ProductInfo/AttachmentsComponent'

export function AdditionalInfo() {
  const { appConfig, loading } = useProductAttributes()

  if (loading) {
    return <ContentSkeleton section="tabContent" />
  }

  if (!appConfig) {
    return null
  }

  return (
    <div className="bg-white xl:mb-5 mb-2" id="productAdditional">
      <SectionHeader size="lg" as="h2" className="!leading-[50px] pl-10 pr-10">
        Specificatii tehnice
      </SectionHeader>
      <div
        className="overflow-auto max-h-[500px] p-3 border-2 border-solid border-cards-bg"
      >
        <SpecificationsTable attributes={appConfig.attributes} />
        <AttachmentsComponent />
      </div>
      <div id="hexamarvel_attachments_react_app" />
    </div>
  )
}
